import React from "react";
import { motion } from "framer-motion";
import { Briefcase, GraduationCap, Heart, Wallet, Activity, Star, Sparkles } from "lucide-react";

const FIELDS = [
  { key: "career", label: "Career", icon: Briefcase },
  { key: "love", label: "Love & Relationships", icon: Heart },
  { key: "finance", label: "Finance", icon: Wallet },
  { key: "health", label: "Health", icon: Activity },
  { key: "education", label: "Education", icon: GraduationCap },
];

function Stars({ value }) {
  const v = Math.max(1, Math.min(5, value || 3));
  return (
    <div className="flex items-center gap-1" data-testid="rating-stars">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} size={15} className={i <= v ? "fill-gold text-gold" : "text-white/15"} />
      ))}
      <span className="ml-2 text-xs text-[#94A3B8] tabular-nums w-9 text-right">{v * 20}%</span>
    </div>
  );
}

export default function HoroscopeResult({ data, sign, compact = false }) {
  const ratings = data.ratings || {};
  const dateStr = new Date().toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });
  return (
    <div data-testid="horoscope-result">
      <div className="flex items-center gap-4 mb-6">
        <span className="text-5xl text-gold">{sign?.symbol}</span>
        <div>
          <h3 className="font-display text-3xl">{sign?.name}</h3>
          <p className="text-[#94A3B8] text-sm">{dateStr}</p>
        </div>
      </div>

      <p className={`font-display leading-snug text-[#F1F5F9] mb-7 ${compact ? "text-xl" : "text-2xl"}`} data-testid="horoscope-reading">
        {data.reading || "Steady, harmonious energies surround you today — trust your intuition."}
      </p>

      <div className="space-y-3.5">
        {FIELDS.map((f, i) => (
          <motion.div
            key={f.key}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.05 + i * 0.06 }}
            className="flex items-center justify-between gap-4 border-b border-white/10 pb-3"
            data-testid={`horoscope-rating-${f.key}`}
          >
            <span className="flex items-center gap-3 text-white text-sm">
              <span className="grid place-items-center h-8 w-8 rounded-lg bg-primary-green/15 text-primary-green"><f.icon size={15} /></span>
              {f.label}
            </span>
            <Stars value={ratings[f.key]} />
          </motion.div>
        ))}
      </div>

      {data.lucky && (
        <div className="mt-6 rounded-xl border border-gold/20 bg-gold/[0.05] p-4 flex items-center gap-3">
          <Sparkles size={18} className="text-gold shrink-0" />
          <p className="text-[#F8FAFC] text-sm"><span className="text-gold">Lucky:</span> {data.lucky}</p>
        </div>
      )}
    </div>
  );
}
